var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import TextAreaField from "../../../shared-library/components/TextAreaField";
import EdButton from "../../../web/components/generic/edbutton/edButton";
import "../../stylesheets/components/Generic/SalesRating.scss";
var SalesRating = function (props) {
    var _a;
    var _b = __read(useState(0), 2), selectedStars = _b[0], setSelectedStars = _b[1];
    var _c = __read(useState(""), 2), commentText = _c[0], setCommentText = _c[1];
    return (React.createElement("div", { className: " ".concat((props === null || props === void 0 ? void 0 : props.className) ? props === null || props === void 0 ? void 0 : props.className : "", "d-flex flex-column align-items-center sales-rating-block") },
        React.createElement("div", null,
            React.createElement("i", { className: "edel-icon-rating-block" },
                React.createElement("span", { className: "path1" }),
                React.createElement("span", { className: "path2" }),
                React.createElement("span", { className: "path3" }),
                React.createElement("span", { className: "path4" }),
                React.createElement("span", { className: "path5" }),
                React.createElement("span", { className: "path6" }),
                React.createElement("span", { className: "path7" }),
                React.createElement("span", { className: "path8" }))),
        React.createElement("div", { className: "rating-text DMSanBold_18_700 txt-midnight-blue" }, props === null || props === void 0 ? void 0 : props.ratingText),
        React.createElement("div", { className: "rating-icons cursor-pointer" }, Array.from({ length: (props === null || props === void 0 ? void 0 : props.totalStars) ? props === null || props === void 0 ? void 0 : props.totalStars : 5 }).map(function (_, index) {
            return (React.createElement("i", { key: index, className: " ".concat(index < selectedStars
                    ? "edel-icon-coloured-star"
                    : "edel-icon-rating-star"), onClick: function () {
                    setSelectedStars(index + 1);
                } }));
        })),
        React.createElement("div", { className: "w-100 DMSanN_16_400 txt_primaryGrey mb-2 pb-1" }, "Comments"),
        React.createElement("div", { className: "w-100 comments-block" },
            React.createElement(TextAreaField, { value: commentText, required: true, placeholderClassName: "", onChangeEvent: function (e) {
                    if (e.target.value.length <= 150) {
                        setCommentText(e.target.value);
                    }
                }, onBlur: function () { }, defaultValue: commentText, placeholder: "Please enter minimum 15 characters." }),
            React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray" },
                commentText.length,
                "/150 Characters")),
        React.createElement("div", { className: "button-block" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", disabled: selectedStars === 0 || ((_a = commentText.trim()) === null || _a === void 0 ? void 0 : _a.length) < 15, onClick: function () {
                    props === null || props === void 0 ? void 0 : props.setShowSalesRating(false);
                    props === null || props === void 0 ? void 0 : props.onSubmit(true, selectedStars, commentText);
                } }))));
};
export default SalesRating;
